var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurguerMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.583 13H1.417C.635 13 0 12.552 0 12s.635-1 1.417-1h31.166c.782 0 1.417.448 1.417 1s-.635 1-1.417 1zM32.583 2H1.417C.635 2 0 1.552 0 1s.635-1 1.417-1h31.166C33.365 0 34 .448 34 1s-.635 1-1.417 1zM32.583 24H1.417C.635 24 0 23.552 0 23s.635-1 1.417-1h31.166c.782 0 1.417.448 1.417 1s-.635 1-1.417 1z",
    transform: "translate(-268.000000, -40.000000) translate(268.000000, 40.000000)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurguerMenu);
export default __webpack_public_path__ + "static/media/burguerMenu.a615176c.svg";
export { ForwardRef as ReactComponent };